import {
  Button,
  TextField,
  Box,
  Grid,
  CssBaseline,
  Typography,
  Link,
  CardMedia,
} from "@mui/material";
import logo from "../../assets/logo.png";
import background from "../../assets/login_background.png";
import { useState } from "react";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { purpleCTA } from "../../components/ColorDefs";
import {
  confirmUpdatePassword,
  forgotPasswordRequest,
} from "../../api/authentication/password/PasswordAPI";
import { OptionsObject, useSnackbar } from "notistack";
import {
  AlertErrorProp,
  AlertSuccessProp,
} from "../../components/SnackbarNoti";
import { useTranslation } from "react-i18next";

const theme = createTheme();
function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://trendz.vn/">
        trendz.vn
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function ConfirmPasswordPage() {
  const { t } = useTranslation(["account", "common"]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = (e: any) => {
    if (password == confirmPassword) {
      e.preventDefault();
      confirmUpdatePassword(password, confirmPassword)
        .then((res) => {
          window.location.href = "/login";
          enqueueSnackbar(
            "Update password successfully. You can login now.",
            AlertSuccessProp as OptionsObject
          );
        })
        .catch((err) => {
          enqueueSnackbar(
            "Failed to update password",
            AlertErrorProp as OptionsObject
          );
        });
    } else enqueueSnackbar("Password and confirm password don't match");
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        component="main"
        sx={{ height: "100vh" }}
        className="fadein"
      >
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 4,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "absolute",
            }}
          >
            <CardMedia
              image={logo}
              sx={{ mx: 2, width: "250px", height: "60px" }}
            />
            <Typography component="h4" variant="h4">
              {t("account:forgot_password")}
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                type={"password"}
                placeholder="Enter your new password"
                value={password}
                autoFocus
                onChange={(e) => {
                  setPassword((e.target as HTMLInputElement).value);
                }}
              ></TextField>

              <TextField
                margin="normal"
                required
                fullWidth
                label="Confirm password"
                type={"password"}
                placeholder="Confirm your password"
                value={confirmPassword}
                autoFocus
                onChange={(e) => {
                  setConfirmPassword((e.target as HTMLInputElement).value);
                }}
              ></TextField>

              <Button
                type="submit"
                fullWidth
                onClick={handleSubmit}
                variant="contained"
                sx={{ mt: 3, mb: 2, backgroundColor: purpleCTA }}
              >
                Update your password
              </Button>
              <Grid container>
                <Grid item>
                  <Link href="/register" variant="body2">
                    {t("account:ask_for_sign_up").toString()}
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
export default ConfirmPasswordPage;
